import { employeeConstants } from '../constant/employee.constants';
import { employee } from '../services/employee.service';
import CONSTANT from '../constant/constant';
import functionCommon from "../common/function";

const _errorCode = CONSTANT.errorCode;

export const getEmployeeList = (data) => {
    const params = {
        ...data,
        startingDate: functionCommon.revertDateFormat(data.startingDate),
        officialDate: functionCommon.revertDateFormat(data.officialDate),
        resignDate: functionCommon.revertDateFormat(data.resignDate),
        isOMSite: Number(data.isOMSite) || "",
    };
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        employee.list(params)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success(res.result));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout();
                            break;
                            
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;

                        case _errorCode.ClientNotPermission:
                            functionCommon.logout();
                            break;
                        
                        default:
                            window.location = '/error/404';
                            break;
                    }
                   
                }
            );
    };

    function success(employeeList) { 
        return { type: employeeConstants.GET_SUCCESS, employeeList }; 
    }
}

export const addEmployeeAction = (data) => {
    const params = {
        ...data,
        startingDate: functionCommon.revertDateFormat(data.startingDate),
        officialDate: functionCommon.revertDateFormat(data.officialDate),
        resignDate: functionCommon.revertDateFormat(data.resignDate),
    };

    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        employee.add(params)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout();
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;

                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: employeeConstants.ADD_SUCCESS, code }; 
    }
    function failure(error) {
        return { type: employeeConstants.ADD_FAILURE, error }; 
    }
};

export const updateEmployeeAction = (data) => {
    const params = {
        ...data,
        startingDate: functionCommon.revertDateFormat(data.startingDate),
        officialDate: functionCommon.revertDateFormat(data.officialDate),
        resignDate: functionCommon.revertDateFormat(data.resignDate),
    };
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        employee.update(params)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APIUpdatedSuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout();
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;

                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: employeeConstants.UPDATE_SUCCESS, code }; 
    }
    function failure(error) {
        return { type: employeeConstants.UPDATE_FAILURE, error }; 
    }
};

export const deleteEmployeeAction = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        employee.delete(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout();
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
    
                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: employeeConstants.DELETE_SUCCESS, code}; 
    }

    function failure(error) {
        return { type: employeeConstants.DELETE_FAILURE, error }; 
    }
}

